// extracted by mini-css-extract-plugin
export default {"item":"lessonItem_item__GfIc8","feature":"lessonItem_feature__jKBpO","fio":"lessonItem_fio__hgmgg","itemMobile":"lessonItem_itemMobile__V+fdA"};